
export default {
  "m": {
    "sms_login": "Inicio de sesión por SMS",
    "get_vercode": "Enviar",
    "change_mobile": "Cambiar el número de móvil",
    "log_reg_agree": "Entrar/Registrarse significa estar de acuerdo {msg_ss}",
    "old_mobile": "Número de móvil original",
    "new_mobile": "Nuevo número de móvil",
    "agency_reginfo_fill": "Rellenar la información de registro del gremio",
    "audit_res": "Resultado de la auditoría",
    "agency_name": "Nombre de la Agencia",
    "agency_name_input": "Por favor, introduzca el nombre de la agencia",
    "agency_name_input_note": "Nota: Se recomienda que el nombre de la agencia sea corto y fácil de recordar, no más de 30 palabras",
    "agency_logo": "LOGOTIPO DEL GRUPO",
    "agency_logo_unpload_note": "Por favor, cargue un logotipo claro de su agencia, en formato PNG/JPG/JPEG",
    "agency_contact_name": "Contacto de la agencia",
    "user_contact_name": "Por favor, rellene el nombre de la persona que está en contacto diario con la plataforma de usuarios",
    "agency_contact_phone": "Teléfono de contacto de la agencia",
    "agency_whatsapp": "WhatsApp del agente",
    "agency_whatsapp_contact": "Por favor, introduzca los datos de contacto de WhatsApp del agente",
    "agency_use_lang": "Lenguaje del agente",
    "agency_head_ID": "ID del agente",
    "agency_ID_input": "Introduzca el ID de usuario de la aplicación BuzzCast para el agente que se utilizará para distribuir los fondos más adelante.",
    "reg_country": "País de registro",
    "inhand_ID_photo": "Identificación con foto a mano",
    "upload_note_t": "Nota para la carga",
    "agency_self_inhand_ID": "Debe ser llevado por el propio agente con el documento del pasaporte",
    "photo_must_clearly": "El anverso debe mostrar claramente la persona y la información real del pasaporte",
    "mian_form_country": "Principal país de origen del streamer",
    "invite_code": "Código de invitación",
    "your_profile_submit_success": "¡Su documento ha sido enviado con éxito! nos ocuparemos de ello lo antes posible.<br>Los resultados de la auditoría se enviarán a la notificación de la BuzzCast APP del líder del gremio, ¡preste atención para verificar!",
    "your_profile_approved": "Su envío no ha sido aprobado. Motivo del rechazo: \"Foto con la mano no clara\".Por favor, rellene de nuevo el formulario o póngase en contacto con el asistente oficial de BuzzCastAPP para obtener más información.",
    "return_refill": "Volver a rellenar",
    "success_agency": "Enhorabuena por haber entrado con éxito en la plataforma, [haz clic en mí] y ponte a trabajar.",
    "personal_account": "Cuenta personal",
    "my_agency": "Mi Agencia",
    "your_agency_been_forcibly": "La plataforma ha dado de baja a tu agencia por la fuerza y ya no podrás conectarte.Si tiene alguna pregunta, póngase en contacto con el asistente oficial de BuzzCastAPP o con la operación exclusiva.",
    "invite_live_join": "Invitar a un streamer a unirse al enlace de la agencia",
    "base_info": "Información básica",
    "apply_time": "Tiempo de aplicación",
    "join_time": "Unirse a la hora",
    "cooper_status": "Estado de la cooperación",
    "streamer_manage": "Gestión de los streamers",
    "sereamer_apply": "Aprobación de la serpentina",
    "sereamer_nickname": "Apodo de streamer",
    "remark": "Comentarios",
    "no_remark": "Sin comentarios",
    "add_remark": "Añadir un comentario",
    "birth": "Año de nacimiento",
    "user_status": "Estado del usuario",
    "temporarily_frozen": "Congelado temporalmente",
    "permanently_frozen": "Congelado permanentemente",
    "fans_num": "Número de ventiladores",
    "sign_status": "Estado de la suscripción",
    "sign_ing": "Bajo contrato",
    "sign_time": "Tiempo de suscripción",
    "release_time": "Tiempo de liberación",
    "live_viola_record": "Registro de violaciones en vivo",
    "sign_record": "Registro de firmas",
    "current_contract_status": "Estado actual del contrato",
    "termination_reason": "Motivo del cese",
    "violation_reason": "Motivo del incumplimiento",
    "violation_time": "Momento de la infracción",
    "processing_result": "Resultado del tratamiento",
    "exported_data": "Datos exportados",
    "join_agency_apply": "Aprobación para entrar en la agencia",
    "audit_status": "Estado de la auditoría",
    "pending_review": "Pendiente",
    "pending_HQ_review": "A la espera de la revisión del cuartel general",
    "not_approved_HQ": "No aprobado por la oficina central",
    "withdrawn": "Retirado",
    "audit_trail": "Registro de auditoría",
    "oper": "Operación",
    "other_video_materials": "Otros materiales de vídeo",
    "pass": "Pasar",
    "pass_streamer_join_agency_apply": "Adoptar la solicitud de afiliación de anclaje",
    "reject_streamer_join_agency_apply": "Rejeitado pedido de adesão de âncora",
    "agree_streamer_join_agency": "Acordar con el ancla {msg_ss1} para convertirse en un emisor por debajo de {msg_ss2}~",
    "reject_streamer_join_agency": "Rechazo de la solicitud del miembro {msg_ss1} para convertirse en miembro de {msg_ss2}.",
    "img_material": "Material fotográfico",
    "approver": "Aprobador",
    'user_enter_bind_phone': 'Introduce tu número de teléfono móvil',
    'vericode': 'Codigo de verificacion',
    'input_vericode': 'Por favor ingrese el código de verificación',
    'login': 'Iniciar sesión',
    'reg': 'Registrado',
    'logout': 'Cerrar sesión',
    'search_for': 'Buscar',
    'subscription_closed': 'Desverificado',
    'agency_ID': 'Código del gremio: {msg_ss}',
    'reset': 'Restablecer con',
    'live_ID': 'ID de transmisión en vivo',
    'live_record': 'Pantalla de grabación en directo',
    'email': 'E-mail',
    'phone': 'Número de teléfono',
    'mastery_lang': 'Lenguaje dominado',
    'to': 'A',
    'cancel': 'Cancelar',
    'Confirm': 'Ok',
    'preview': 'Preestreno',
    'rejected': 'Rechazado',
    'tip': 'Consejos',
    'i_got_it': 'Entiendo',
    'cancelled': 'Ha sido cancelado',
    'refused': 'Desperdicios',
    'agency_agree': 'La agencia ha dado permiso',
    'platform_agree': 'La plataforma ha aceptado',
    'user_not_exist': 'Este usuario no existe',
    'user_frozen': 'El usuario ha sido congelado.',
    'reviewing': 'En revisión',
    'review_pass': 'Revisión aprobada',
    'review_failed': 'Error en la auditoría',
    'xx_hours': '{msg_ss} horas',
    'xx_days': '{msg_ss} días',
    'xx_hour': '{msg_ss} hora',
    'xx_day': '{msg_ss} día',
    'xx_year': '{msg_ss} año',
    'xx_years': '{msg_ss} años',
    'check_phone_istrue': 'Verifique si el número de teléfono se ingresó correctamente',
    'male': 'Hombre',
    'female': 'Mujere',
    'avatar': 'Foto de perfil',
    'normal': 'Normal',
    'live_room': 'Sala en vivo',
    'view': 'Ver',
    'oper_success': 'Operación exitosa',
    'copy_success': 'Copia exitosa',
    'new_mobile_already_reg': 'Se ha registrado un nuevo número de móvil',
    'general_user': 'Usuario general',

    'copy': 'Copiar',
    'gender': 'Sexo',
    'submit': 'Enviar',
    'permanent': 'Permanente',
    'agree_agreement': 'Acepte y cumpla el acuerdo de contratación',
    'vericode_error': 'El código de verificación es incorrecto',
    'resend': 'Reenviar',
    'approved': 'Aprobado',
    'not_approved': 'Sin éxito',
    'agency_rejected': 'La plataforma ha rechazado',
    'select': 'Seleccionar',
    'search': 'Buscar',
    'rejection_reason': 'Motivo del rechazo',
    'no_data': 'Sin datos',
    'oper_failed': 'operación fallida',
    'leave_agency_apply': 'Aprobación para dejar la agencia',
    'over_word_limit': 'Por encima del límite numérico',
    'delete': 'Borrar',
    'nickname': 'Apodo',
    'file_is_too_large': 'Archivo demasiado grande',

    'community_convention': 'Convención de la comunidad de Buzzcast',
    'approval_time': 'Tiempo de aprobación',
    'guild_system_title': 'Sistema de gremios de la plataforma social BuzzCast',
    'return': 'Volver',
    'img_upload_fail': 'Error en la carga de imágenes',
    'cooper_ing': 'En cooperación',
    'upload_file_format_incorrect': 'El archivo subido no tiene el formato correcto',
    'token_invalid': 'El token no es válido, ¡inicia sesión de nuevo!',
    'network_busy': 'La red está ocupada, intente nuevamente',
    'minute': '{msg_ss}minutos',

    'live_room_ID': 'ID de la sala en vivo',
    'scan_code': 'BuzzCast APP Escanear el código para iniciar sesión',
    'open_code': 'Abre la BuzzCastApp y haz clic en mi código QR para escanear',
    'refresh': 'Refrescar',
    'login_confirm': 'Confirmación de inicio de sesión',
    'account': 'Información de la cuenta',
    'user_name': 'Nombre de usuario',
    'edit': 'Modificaciones',
    'changing': 'Cambiar la vinculación',
    'mobile_number': 'Cuenta de teléfono móvil',
    'mobile_login': 'Puede utilizar tu número de móvil {msg_ss} para iniciar la sesión',
    'appId_login': 'Puede escanear el código QR para iniciar sesión utilizando tu AppID',
    'code_login': 'BuzzCast no está vinculado con el AppID, después de la vinculación, puede utilizar el código QR para escanear el código de inicio de sesión',
    'verification_log': 'Número de teléfono móvil sin vincular, después de vincular, puede utilizar su número de teléfono móvil y el código de verificación para iniciar sesión',
    'binding_success': 'Vincular con éxito',
    'binding_mobile': 'Vincular el número de teléfono móvil',
    'edit_name': 'Cambiar el nombre de usuario',
    'binding_alert': 'El aviso de cambiar la vinculación',
    'new_appId': 'Utilice el nuevo APPID para escanear y vincular directamente, el APPID original será reemplazado directamente',
    'binding_account': 'Vinculación con tu cuenta de BuzzCastApp',
    'anchor_earings': 'Ganancias de anclaje',
    'signing_date': 'Fecha de la firma',
    'statistical_date': 'Fecha estadística',
    'valid_min': 'Tiempo efectivo total (minutos)',
    'valid_day': 'Días válidos (días)',
    'total_revenue': 'Ingresos totales',

    'bind': 'Enlazar',
    'please_agree_agree': 'Por favor, acepte el acuerdo',
    'note': 'Nota: Todas las horas mostradas en este sistema son en Nueva York, EE.UU. (EST)',
    'app_phone': 'Registrar el número de teléfono móvil de la APP',
    'host_num': 'Número de anfitrión',
    'enter_host_num': 'Ingrese su número de todos los host',
    'platform': 'Plataforma de cooperación',
    'statement': 'Extracto bancario mensual',
    'enter_income': 'Por favor ingrese el ingreso mensual promedio',
    'check_commas': 'Formato incorrecto. Verifique si las múltiples plataformas están separadas por comas',
    'submit_success': '¡Su documento ha sido enviado con éxito! nos ocuparemos de ello lo antes posible',
    'usd': 'USD',
    'many_platforms': 'Ingrese la plataforma de transmisión en vivo con la que ha cooperado anteriormente, hasta 20 plataformas',
    'limit_platform': 'Hasta 20 plataformas',
    'user_has_delete': 'Este usuario ha sido desconectado',
    'cant_commit': 'Ya eres un locutor contratado y no puedes solicitar que un gremio se establezca al mismo tiempo',
    'cant_commit_1': 'Ya ha solicitado una emisora contratada y no puedes solicitar que un gremio se establezca al mismo tiempo',
    'passwd': 'Contraseña',
    'passwd_placeholder': 'La contraseña soporta 6 a 20 carácteres',
    'live_rights': 'Evaluación sin tiempo',
    'edit_log': 'Cambiar registro',
    'edit_time': 'Cambiar la hora',
    'edit_pwd': 'Cambiar la contraseña',
    'old_pwd': 'Contraseña anterior',
    'new_pwd': 'Nueva contraseña',
    'confirm_pwd': 'Confirmar contraseña',
    'forget_pwd': '¿Olvidaste tu contraseña?',
    'email_check': 'Formato de correo electrónico es incorrecto',
    'phone_pwd_error': 'Error de número de teléfono o contraseña',
    'ten_min_error': 'Por favor, inténtelo de nuevo en 10 minutos',
    'phone_bind_error': 'El número de teléfono se ha vinculado a otra cuenta; cámbielo por un nuevo número de teléfono móvil para vincularlo.',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'La ID del líder del gremio ya se ha completado, por favor complete nuevamente',
    'pwd_error': 'Contraseña incorrecta',
    'phone_not_reg_error': 'Cuenta no registrada',
    'pwd_nq': 'Contraseña inconsistente ingresada dos veces',
    'sign_anchor_error': 'Ya eres un locutor contratado y no puedes solicitar que un gremio se establezca al mismo tiempo',
    'apply_anchor_error': 'Ya has solicitado una emisora contratada y no puedes solicitar que un gremio se establezca al mismo tiempo',
    'have-expired': 'Caducado',
    'approval-time': 'Tiempo de aprobación',
    'reasons-for-refusal': 'Indique el motivo de la denegación',
    'Transfer-grounds': 'Razones para la transferencia',
    'code_expire': 'El código de verificación ha caducado. Haga clic en el código de verificación para actualizarlo.',
    'transfer-approval': 'Aprobación de transferencia',
    'live_state_placeholder': 'Estado en el vivo',
    'live_state_open': 'Normal',
    'live_state_temporary_banned': 'Prohibido',
    'live_state_forever_banned': 'Prohibición permanente',
    'live_allowed_time': 'Hora de inicio permitida',
    'live_banned_time': 'Período de prohibición',
    'deduct_money': 'Deducir la cantidad de monedas B',
    'final_income': 'Ingresos reales',
    'select_start_dt': 'Por favor, seleccione una hora de inicio',
    'select_end_dt': 'Por favor, seleccione una hora final',
    'less_then_end_dt': 'La hora de inicio debe ser menor o igual a la hora de fin',
    'System_automatically_through': 'El sistema pasa automáticamente',
    'btrade_err': 'La identificación de la agencia no está disponible',

    'mouth_anchor': 'Streamer de salário mensal',
    'day_anchor': 'Streamer de salario diario',
    'guild_anchor': 'Recompensa del agente (salario diario)',
    'mouth_anchor_st': 'Hora de inicio del salario mensual',
    'mouth_anchor_et': 'Hora de finalización del salario mensual',
    'day_anchor_st': 'Hora de inicio del salario diario',
    'day_anchor_et': 'Hora de finalización del salario diario',
    'all_award_bcoin': 'Ingreso total diario de recompensa salarial',
    'live_hour': 'Recompensa de duración válida de transmisión en vivo',
    'salary_day': 'Fecha',
    'day_in_come': 'Ingresos diarios de agente (monedas B)',
    'award_ration_flag_str': 'Relación de recompensa',
    'payable_money': 'Recompensa del agente en moneda B',
    'host_bcoins': 'Ganancias de Bcoins del streamer',
    'total_official': 'El número total de monedas B de recompensa oficial',
    'actual_bcoins_awarded': 'Monedas B de recompensa real',
    "change_bound_account":"Cambiar cuenta vinculante" ,
    "agent_id_form":"ID de Agente:" ,
    "BuzzCast_verification_code":"Código de verificación de BuzzCast." ,
    "send_success":"Enviar éxito" ,
    "account_changed_successfully":"Cuenta vinculada cambiada con éxito" ,
    "invite_guild_url":"Enlace de invitación para convertirse en agente de BuzzCast: {msg_ss}" ,
    "invite_guild_code":"Mi código de invitación:{msg_ss}" ,
    "save":"Salvar" ,
    "compile":"Editar" ,
    "agent_nvitation_eward":"Recompensa por invitación a agentes" ,
    "agent_name":"Apodo del agente" ,
    "guild_id":"Código de agencia" ,
    "guild_income_30days":"Ganancias de la agencia en los últimos 30 días" ,
    "guild_invite_income_30days":"Ganancias de la agencia invitado en los últimos 30 días" ,
    "agency_commission_ratio":"Ratio de comisión de agencia" ,
    "invite_income_bcoins":"Las invitaciones recompensan con monedas B" ,
    "id_not_exist": "El ID no existe",
    'reward_distribution_status': 'Estado de distribución de recompensas',
    'must_number': 'Su entrada debe estar en formato puramente numérico.',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/es.js